module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('i', [_vm._v("The Reiki Teacher’s Manual – Second Edition: A Guide for Teachers, Students, and Practitioners Book One of The Reiki Healing Series")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "crt1"
  }, [_vm._v("©2020 by Tina M. Zion. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("No part of this book may be reproduced in any form or by any means, electronic, mechanical, or digital (including photocopying and recording other than the included worksheets that are intended for photocopying) except for the inclusion in a review, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Because of the dynamic nature of the Internet, any web addresses or links contained in this book may have changed since publication and may no longer be valid. The views expressed in this work are solely those of the author and do not necessarily reflect the views of the publisher, and the publisher hereby disclaims any responsibility for them.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Limit of Liability/Disclaimer of Warranty: All effort has been done to ensure accuracy and ownership of all included information. While the publisher and author have used their best efforts in preparing this book, they make no representations or warranties with respect to the accuracy or completeness of this book and specifically disclaim any implied warranties of merchantability or fitness for a particular purpose. No warranty may be created by sales representatives or written promotional materials. The advice and strategies contained herein may not be suitable for your situation. The publisher is not engaged in rendering professional services, and you should consult a professional where appropriate. Neither the publisher nor the author shall be liable for any loss of profit or any other damages, including but not limited to special, incidental, consequential, or other damages incurred as a result of using the techniques contained in this book or any other source reference.")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Published in the United States by WriteLife Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("(An imprint of Boutique of Quality Books Publishing Company, Inc.)")])]), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.writelife.com",
      "id": "AZI",
      "target": "_blank"
    }
  }, [_vm._v("www.writelife.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("978-1-60808-225-4 (p)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("978-1-60808-226-1 (e)")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Library of Congress Control Number: 2014956544")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Book and cover design by Robin Krauss, "), _c('a', {
    attrs: {
      "href": "http://www.bookformatters.com",
      "id": "AUV1",
      "target": "_blank"
    }
  }, [_vm._v("www.bookformatters.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Cover artwork by Corey Ford, "), _c('a', {
    attrs: {
      "href": "http://www.coreyfordgallery.com",
      "id": "Atv",
      "target": "_blank"
    }
  }, [_vm._v("www.coreyfordgallery.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Toroidal Field illustration by Jacqueline Rogers, "), _c('a', {
    attrs: {
      "href": "http://www.jacquelinerogers.com",
      "id": "AvBE",
      "target": "_blank"
    }
  }, [_vm._v("www.jacquelinerogers.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Editor: Olivia Swenson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 60
// module chunks = 0